import { ModalSizes } from '../GlobalModal';
import {
  ModalActionButton,
  ModalBody,
  ModalContainerWrapper,
  ModalContentWrapper,
  ModalFooterWrapper,
  ModalHeaderContent,
  ModalHeaderWrapper,
  ModalOverlay,
  ModalTitle,
} from '../GlobalModal/GlobalModal.styled';
import { ISecretModal } from './ISecretModal';

export const SecretModal = ({ handleConfirmButtonClick, handleCancelButtonClick, title, children }: ISecretModal) => {
  const ModalBodyClassName = 'globalModalBody';

  return (
    <>
      <ModalOverlay></ModalOverlay>
      <ModalContainerWrapper size={ModalSizes.SMALL}>
        <ModalContentWrapper>
          <ModalHeaderWrapper>
            <ModalHeaderContent>
              <ModalTitle>{title || 'Title'}</ModalTitle>
            </ModalHeaderContent>
          </ModalHeaderWrapper>
          <ModalBody className={ModalBodyClassName}>{children}</ModalBody>
          <ModalFooterWrapper>
            <ModalActionButton onClick={handleConfirmButtonClick}>Ok</ModalActionButton>
            {handleCancelButtonClick && <ModalActionButton onClick={handleCancelButtonClick}>Cancel</ModalActionButton>}
          </ModalFooterWrapper>
        </ModalContentWrapper>
      </ModalContainerWrapper>
    </>
  );
};

export default SecretModal;
